import { phaseOf, type PhaseInput, type PhaseResult } from '@/lib/task-phase';
import { useServerTick } from '@/lib/task-tick';

/**
 * Bir satirin YASAYAN fazi.
 *
 * Faz SAKLANMAZ, her tikte yeniden turetilir (bkz. src/lib/task-phase.ts). Sayac
 * dolunca satir kendiliginden bir sonraki faza gecer ve BUNUN ICIN AG ISTEGI
 * ATILMAZ — mobil tarafta dolan her sayac tum listeyi yeniden cektiriyordu.
 *
 * Nabiz yalniz aktif satirlar icin calisir: 'passive' bir satir aboneligi
 * dusurur, boylece gecmis listeleri saniyede bir yeniden cizilmez.
 */
export const useCountdown = (input: PhaseInput): PhaseResult => {
  // Ilk hesap tiksiz yapilir: satir 'passive' ise hic abone olmayacagiz.
  const idle = phaseOf(input, useServerTick(false));
  const nowMs = useServerTick(idle.phase !== 'passive');
  return phaseOf(input, nowMs);
};
